import React from 'react';
import styled, {keyframes} from 'styled-components'

// STYLED CONTAINERS

// Forms for specs

const SessionForm = styled.form`
  display: flex;
  margin-right: 20px;
  flex-direction: column;
`;

const SessionTextArea = styled.textarea`
  display: block;
  box-sizing: border-box;
  margin: 0;
  width: 100%;
  resize: vertical;
  height: 250px;
`;

const InputTextBox = styled.input`
  border: 1px solid #A6A6A6;
  box-sizing: border-box;
  height: 40px;
  padding: 0 15px;
  color: #6B6B6B;
  display: block;
  font-size: 11px;
  width: 30%;
  margin-bottom: 1rem;
`

const NumberTextArea = styled.input`
  display: block;
  box-sizing: border-box;
  margin: 0;
  resize: vertical;
  height: 20px;
  width: 100%;
  margin-top: -5px;
`;

const InputFileBox = styled.input`
  box-sizing: border-box;
  padding: 0 15px;
  display: block;
  width: 100%;
  margin-bottom: 1rem;
  justify-content: left;
`

const FormLabel = styled.div`
  color: #4F4F4F;
  margin-bottom: 10px;
  margin-top: 10px;
  margin-left: 5px;
  margin-right: 5px;
  size: 20px;
`;

const FormError = styled.div`
  font-size: 11px;
  color: #A31A1A;
`;

const SubmitRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px
`;

const FormHeader = styled.label`
  text-transform: uppercase;
  margin-top: 1rem;
  color: #6B6B6B;
  font-size: 11px;
  width: 30%;
`

const FormDescription = styled.label`
  margin-bottom: 0.5rem;
  color: #6B6B6B;
  font-size: 9.5px;
  width: 30%;
`

const FlexForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
  width: 100%;
`

const InputFields = styled.div`
  max-width: 800px;
  flex: 1 1 auto;
  float: left;
  > * {
    margin-bottom: 12px;
  }
`;

export const FormField = ({label, error, children, props}) => {
  return (
    <div>
      {!!label &&
        <FormLabel>{label}</FormLabel>
      }
      <div>
        {children}
      </div>
      {!!error &&
        <FormError>
          {error}
        </FormError>
      }
    </div>
  );
}

export const ScriptText = ({label, text, onChange, props}) => {
  return (
    <div style={{width: "500px", marginTop: "16px"}}>
      <hr/>
      <h3>{label}:</h3>
      <textarea
        name="script"
        // Height is just set to roughly fit content
        style={{width: "100%", height: "240px"}}
        value={text}
        onChange={onChange}
      />
    </div>
  );
}

// General page formatting

const FlexContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`

const MultiLineText = styled.div`
  white-space: pre-line;
`;

const GSButton = styled.div`
  align-items: center;
  background: #1BA69B;
  border: 1px solid #1BA69B;
  display: flex;
  color: white;
  font-weight: 600;
  height: 40px;
  justify-content: center;
  margin: 2rem;
  width: 20rem;
  text-decoration: none;

  &:hover {
    background-color: transparent;
    border-color: #1BA69B;
    color: #1BA69B;
    text-decoration: none;
  }

  a:visited {
    color: white;
    text-decoration: none;
  }

  &:disabled,
  &--disabled {
    pointer-events: none;
    opacity: 0.5;
  }`

const GSInputButton = styled.input`
  align-items: center;
  background: #1BA69B;
  border: 1px solid #1BA69B;
  display: flex;
  color: white;
  font-weight: 600;
  height: 40px;
  justify-content: center;
  margin: 2rem;
  width: 20rem;
  text-decoration: none;

  &:hover {
    background-color: transparent;
    border-color: #1BA69B;
    color: #1BA69B;
    text-decoration: none;
  }

  a:visited {
    color: white;
    text-decoration: none;
  }`

const PaleBox = styled.div`
  border-radius: 11px;
  border: 2px solid #FFF;
  background: #FFFFFF40;
  display: flex;
  color: white;
  font-weight: 400;
  width: 15%;
  justify-content: center;
  margin: 2rem;
  text-align: left;
  flex-direction: column;
  padding: 20px;
`

const TipsBox = styled.div`
  border: 1px solid #204860;
  border-radius: 8px;
  background-color: #f2f2f2;
  padding: 16px;
  color: #204860;
  font-family: 'Inter';
  // font-size: 14px;
  font-style: normal;
  font-weight: 500; 
  margin-bottom: 10px;
`;

const PrettyButton = styled.button`
  color: #204860;
  font-family: 'Inter';
  padding: 5px 10px;
  font-size: 1em;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #204860;
    color: #fff;
  }
`;

const RowFlexDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0.7rem;
`

const ColFlexDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0.7rem;
`

const FlexGrowBox = styled.div`
  flex-grow: 1;
  margin: 10px;
  padding: 15px;
`;

const InstructionDivider = styled.div`
  border-bottom: 2px solid rgb(32, 72, 96, 0.28); 
  margin-top: 16px;
  margin-bottom: 16px;
  width: 100%;
`

const SessionInfoContainer = styled.div`
    display: flex; 
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: white;
    width: 80%;
    height: 178px;
    flex-shrink: 0;
    margin: auto;
    border: 2px solid #20486040;
    margin: 20px 0 20px 0;
  `

const SessionClickableContainer = styled.div`
    display: flex; 
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: white;
    width: 80%;
    height: 178px;
    flex-shrink: 0;
    margin: auto;
    border: 2px solid #20486040;
    margin: 20px 0 20px 0;

    &:hover {
      cursor: pointer;
      background: #D5DCE07D;
    }
`

const SessionPremise = styled.div`
  color: #204860;
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`
const CountdownWrapper = styled.div`
  background-color: #ECC100;
  color: black;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 8px;
  display: inline-block;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

const RoleDetailsContainer = styled.div`
  display: flex; 
  background: rgb(161, 181, 188, 0.25);
  width: 100%;
  padding: 10px;
  flex-shrink: 0;
  margin: auto;
  border-radius: 10px;
  border: 2px solid #1f4760;
  margin: 20px 0 20px 0;
  flex-direction: column;
`

const MixerlabText = styled.div`
    color: #204860;
    font-family: 'Inter';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 30px; 
    white-space: pre-line;
    margin-top: 20px;
    margin-bottom: 20px;
`

const Header = styled.div`
    color: #204860;
    font-family: 'Inter';
    font-size: 14px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    text-transform: uppercase;
    margin-top: 20px;
    margin-bottom: 16px;
`

const InformationItem = styled.div`
  color: #204860;
  font-family: 'Inter';
  // font-size: 14px;
  font-style: normal;
  font-weight: 500; 
  margin-bottom: 10px;
`;

const BigFigure = styled.div`
  margin-top: 10px;
  font-size: 2em;
  font-weight: bold;
`;

export { 
  GSInputButton, 
  GSButton, 
  PaleBox, 
  TipsBox,
  InputTextBox, 
  NumberTextArea,
  InputFileBox,
  FormHeader, 
  FlexForm, 
  FlexContainer, 
  FormDescription, 
  SessionClickableContainer, 
  SessionInfoContainer, 
  InstructionDivider, 
  RowFlexDiv, 
  ColFlexDiv,
  FlexGrowBox,
  SessionTextArea,
  FormLabel,
  InformationItem,
  BigFigure,
  MixerlabText,
  Header,
  InputFields,
  SessionForm,
  SubmitRow,
  PrettyButton,
  CountdownWrapper,
  RoleDetailsContainer,
  SessionPremise,
  MultiLineText
}

// PROFILE LOGOS BADGES AND WRAPPERS

export const EmailSymbol = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
      <path fill="#CCCCCC" d="M22,7.18V18c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V7.18l10,7L22,7.18z"/>
    </svg>
  );
};

export const SlackLogo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 60 60" preserveAspectRatio="xMidYMid meet" alt="Slack Logo">
      <title>Slack Logo SVG</title>
      <path d="M22,12 a6,6 0 1 1 6,-6 v6z M22,16 a6,6 0 0 1 0,12 h-16 a6,6 0 1 1 0,-12" fill="#36C5F0"/>
      <path d="M48,22 a6,6 0 1 1 6,6 h-6z M32,6 a6,6 0 1 1 12,0v16a6,6 0 0 1 -12,0z" fill="#2EB67D"/>
      <path d="M38,48 a6,6 0 1 1 -6,6 v-6z M54,32 a6,6 0 0 1 0,12 h-16 a6,6 0 1 1 0,-12" fill="#ECB22E"/>
      <path d="M12,38 a6,6 0 1 1 -6,-6 h6z M16,38 a6,6 0 1 1 12,0v16a6,6 0 0 1 -12,0z" fill="#E01E5A"/>
    </svg>
  );
};


const PayPalButton = styled.button`
  border: none;
  font-family: 'Open Sans', sans-serif;
  height: 48px;
  width: 100%;
  background-color: #FCBB32;
  color: black;
  font-size: 16px;
  font-weight: 400;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #EEEEEE;
  }
`;

const Pay = styled.span`
  color: #253B80; /* PayPal blue for "Pay" */
  font-style: italic;
  font-weight: bold;
  font-size: 1.2em;
`;

const Pal = styled.span`
  color: #2997D8; /* PayPal blue for "Pal" */
  font-style: italic;
  font-weight: bold;
  font-size: 1.2em;
`;

const Badge = styled.div`
  display: inline-block;
  padding: 8px 12px;
  margin: 5px;
  border-radius: 20px;
  font-size: 1em;
  font-weight: bold;
  color: #fff;
  box-shadow: 2px 4px 8px #4F4F4F;
`;

const MaestroBadge = styled(Badge)`
  background-color: #e74c3c;
`;

const MegaMaestroBadge = styled(Badge)`
  background-color: #800000;
`;

const InfluencerBadge = styled(Badge)`
  background-color: #ECC100;
`;

const XpertBadge = styled(Badge)`
  background-color: #64B6D8;
`;

const EnthusiastBadge = styled(Badge)`
  background-color: #1CA79D;
`;

const RookieBadge = styled(Badge)`
  background-color: #9b59b6;
`;

const ProvisionalBadge = styled(Badge)`
  background-color: #4F4F4F;
`;

const RejectedBadge = styled(Badge)`
  background-color: #4F4F4F;
`;

const Emoji = styled.span`
  margin-right: 2px;
`;

const ProfileWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ColumnProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 30%;
  overflow:hidden;
  height:1%;
`;

const ProfileHeader = styled.h2`
  font-family: 'Inter';
  font-size: 1.5em;
  margin-bottom: 10px;
`;

export { PayPalButton, Pay, Pal, Badge, MaestroBadge, MegaMaestroBadge, InfluencerBadge, XpertBadge, EnthusiastBadge, RookieBadge, ProvisionalBadge, RejectedBadge, Emoji, ProfileHeader, ProfileWrapper, ColumnProfileWrapper}


// ICONS & ANIMATIONS

const LoadingSVG = styled.svg`
  fill: none;
  width: 45px;
  height: 45px;
  margin: 45px;
`

const TraceOuter = keyframes`
  to {
    stroke-dashoffset: 188;
  }
`
const TraceInner = keyframes`
  from { stroke-dashoffset: 85; }
  to { stroke-dashoffset: -115; }
`

const LoadingOuterPath = styled.path`
    stroke: #365C73;
    stroke-width: 0.5;
    stroke-dasharray:188;
    animation: ${TraceOuter} 1.5s ease-in-out infinite;
    animation-direction: alternate;
`

const LoadingInnerPath = styled.path`
    stroke: #365C73;
    stroke-width: 0.5;
    stroke-dasharray:115;
    animation: ${TraceInner} 1.5s ease-in-out infinite;
    animation-direction: alternate;
`

export const GridspaceLogo = () => (
  <svg className="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-18.000000, -17.000000)">
        <path d="M30.0001039,17 C23.3832106,17 18,22.38313 18,28.9999481 C18,35.6167661 23.3832106,41 30.0001039,41 C36.6168933,41 42,35.6167661 42,28.9999481 C42,22.38313 36.6168933,17 30.0001039,17 L30.0001039,17 Z M30.0001039,39.8575039 C24.0132425,39.8575039 19.1424912,34.9868353 19.1424912,28.9999481 C19.1424912,23.0131647 24.0132425,18.1424961 30.0001039,18.1424961 C35.9868614,18.1424961 40.8575088,23.0131647 40.8575088,28.9999481 C40.8575088,29.2477659 40.8483689,29.4934025 40.8319586,29.7369619 L34.1797519,29.7369619 L34.1797519,24.3652569 C34.1797519,22.0605307 32.3047162,20.1855907 30.0001039,20.1855907 C27.6952838,20.1855907 25.8202481,22.0605307 25.8202481,24.3652569 C25.8202481,26.6699831 27.6952838,28.5450269 30.0001039,28.5450269 L33.0372608,28.5450269 L33.0372608,29.7369619 L30.0001039,29.7369619 C27.6952838,29.7369619 25.8202481,31.6120057 25.8202481,33.9167319 C25.8202481,36.2214582 27.6952838,38.096502 30.0001039,38.096502 C32.3047162,38.096502 34.1797519,36.2214582 34.1797519,33.9167319 L34.1797519,32.0219541 L33.0372608,32.0219541 L33.0372608,33.9167319 C33.0372608,35.5915274 31.6747882,36.9540059 30.0001039,36.9540059 C28.3253157,36.9540059 26.9627392,35.5915274 26.9627392,33.9167319 C26.9627392,32.2420404 28.3253157,30.879458 30.0001039,30.879458 L40.6942365,30.879458 C39.8015354,35.9736404 35.3460277,39.8575039 30.0001039,39.8575039 L30.0001039,39.8575039 Z M33.0372608,24.3652569 L33.0372608,27.4025308 L30.0001039,27.4025308 C28.3253157,27.4025308 26.9627392,26.0400523 26.9627392,24.3652569 C26.9627392,22.6905653 28.3253157,21.3280868 30.0001039,21.3280868 C31.6747882,21.3280868 33.0372608,22.6905653 33.0372608,24.3652569 L33.0372608,24.3652569 Z" />
      </g>
    </g>
    </svg>
  );

  export const DeltaRightIcon = (props) => (
    <svg {...props} width="7" height="10" viewBox="0 0 7 10" fill="#204860" xmlns="http://www.w3.org/2000/svg">
      <rect width="9" height="6" fill="black" fillOpacity="0" transform="translate(0.5 9.5) rotate(-90)"/>
      <path d="M6.5 5L2 8.89711L2 1.10289L6.5 5Z" />
    </svg>
  );
  
  export const DeltaUpIcon = (props) => (
    <svg {...props} width="9" height="5" viewBox="0 0 9 5" fill="#204860" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.5 3.93402e-07L8.39711 4.5L0.602885 4.5L4.5 3.93402e-07Z" fill="#3D3D3D"/>
    </svg>
  );
  
  export const DeltaDownIcon = (props) => (
    <svg {...props} width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.5 5L0.602885 0.5L8.39711 0.5L4.5 5Z" fill="#3D3D3D"/>
    </svg>
  );

  export const GridspaceLoadingIcon = (props) => (
    <LoadingSVG viewBox="98 98 32 32">
      <g fillRule="evenodd" strokeWidth="1">
        <LoadingOuterPath
          d="M113.500126,126.619484 C106.266001,126.619484 100.38051,120.734093 100.38051,113.499937 C100.38051,106.265907 106.266001,100.380516 113.500126,100.380516 C120.734124,100.380516 126.61949,106.265907 126.61949,113.499937 C126.61949,113.799384 126.608446,114.096195 126.588617,114.390496 L118.550534,114.390496 L118.550534,107.899685 C118.550534,105.114808 116.284865,102.849255 113.500126,102.849255 C110.715135,102.849255 108.449466,105.114808 108.449466,107.899685 C108.449466,110.684563 110.715135,112.950241 113.500126,112.950241 L117.170023,112.950241 L117.170023,114.390496 L113.500126,114.390496 C110.715135,114.390496 108.449466,116.656174 108.449466,119.441051 C108.449466,122.225929 110.715135,124.491607 113.500126,124.491607 C116.284865,124.491607 118.550534,122.225929 118.550534,119.441051 L118.550534,117.151528 L117.170023,117.151528 L117.170023,119.441051 C117.170023,121.464762 115.523702,123.11109 113.500126,123.11109 C111.476423,123.11109 109.829977,121.464762 109.829977,119.441051 C109.829977,117.417465 111.476423,115.771012 113.500126,115.771012 L126.422202,115.771012 C125.343522,121.926482 119.959783,126.619484 113.500126,126.619484 L113.500126,126.619484 Z "
        />
        <LoadingInnerPath
          d="M117.170023,107.899685 L117.170023,111.569725 L113.500126,111.569725 C111.476423,111.569725 109.829977,109.923397 109.829977,107.899685 C109.829977,105.8761 111.476423,104.229772 113.500126,104.229772 C115.523702,104.229772 117.170023,105.8761 117.170023,107.899685 L117.170023,107.899685 Z"
        />
      </g>
    </LoadingSVG>
  );
  
  export const MixerLogo = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="95" height="19" viewBox="0 0 95 19" fill="none">
      <path d="M36.6027 16.574L36.3977 16.783H33.8889L33.6798 16.574V8.42456H33.4708L30.1258 16.574L29.9167 16.783H27.6211L27.412 16.574L24.067 8.42456H23.8579V16.574L23.6489 16.783H21.1401L20.931 16.574V2.3453L21.1401 2.13623H24.276L24.4851 2.3453L28.6664 12.5935H28.8755L33.0568 2.3453L33.2658 2.13623H36.4018L36.6067 2.3453L36.6027 16.574Z" fill="white" />
      <path d="M43.2846 16.574L43.0755 16.783H40.5667L40.3577 16.574V2.3453L40.5667 2.13623H43.0755L43.2846 2.3453V16.574Z" fill="white" />
      <path d="M79.9487 16.574L79.7396 16.783H69.9013L69.6922 16.574V2.3453L69.9013 2.13623H79.7396L79.9487 2.3453V4.43594L79.7396 4.645H72.8405L72.6314 4.85407V7.78097L72.8405 7.99003H79.3215L79.5306 8.1991V10.2897L79.3215 10.4988H72.8405L72.6314 10.7079V14.0529L72.8405 14.262H79.7396L79.9487 14.471V16.574Z" fill="white" />
      <path d="M94.9972 6.54317C95.0333 7.53813 94.7136 8.51338 94.0954 9.2938C93.5276 10.0026 92.7426 10.5053 91.8613 10.7245V10.954L94.5791 14.5081V16.5947L94.37 16.8037H93.1157L92.7057 16.5947L88.5244 11.1631L88.1145 10.954H86.0239L85.8148 11.1631V16.5947L85.6057 16.8037H83.097L82.8879 16.5947V2.34549L83.097 2.13642H89.9961C91.3077 2.0704 92.6003 2.47125 93.6445 3.26783C94.5381 4.0344 94.9972 5.12071 94.9972 6.54317ZM91.5374 8.00662C91.8818 7.59673 92.0706 7.07852 92.0706 6.54317C92.0706 6.00782 91.8818 5.48962 91.5374 5.07972C91.0781 4.77386 90.5301 4.62963 89.9797 4.66979H86.0075L85.7984 4.87886V8.22389L86.0075 8.43295H89.9797C90.5319 8.46831 91.0802 8.31826 91.5374 8.00662Z" fill="white" />
      <path d="M65.5027 16.7381H61.6084C61.1117 16.738 60.6206 16.6332 60.1671 16.4305C59.7136 16.2277 59.308 15.9317 58.9766 15.5616L50.5772 4.94033C50.4521 4.80779 50.3007 4.70286 50.1327 4.63227C49.9647 4.56167 49.7837 4.52698 49.6015 4.5304H46.5558V2.28809H49.6015C50.0989 2.28814 50.5906 2.39293 51.0447 2.59563C51.4989 2.79834 51.9053 3.09442 52.2374 3.46459L60.6492 14.0818C60.7713 14.2187 60.9209 14.3282 61.0884 14.4031C61.2558 14.478 61.4373 14.5165 61.6207 14.5163H65.515L65.5027 16.7381Z" fill="#F7C964" />
      <path d="M62.6742 18.6402L65.0846 15.6272L62.6742 12.6143H64.6296L67.6426 15.6272L64.6296 18.6402H62.6742Z" fill="#F7C964" />
      <path d="M65.4577 2.24292H61.5633C61.0656 2.24271 60.5734 2.3478 60.1191 2.55127C59.6648 2.75474 59.2587 3.05199 58.9275 3.42352L50.5157 14.0407C50.3932 14.1769 50.2434 14.2856 50.0759 14.3598C49.9085 14.4339 49.7273 14.4719 49.5442 14.4711H46.4779V16.693H49.5278C50.0246 16.6934 50.5158 16.5888 50.9694 16.386C51.4229 16.1833 51.8285 15.8869 52.1595 15.5165L60.5713 4.89927C60.6942 4.76226 60.8446 4.65274 61.0127 4.57786C61.1808 4.50298 61.3629 4.46444 61.5469 4.46474H65.4413L65.4577 2.24292Z" fill="#F7C964" />
      <path d="M62.6292 0.34082L65.0354 3.35381L62.6292 6.36679H64.5804L67.5934 3.35381L64.5804 0.34082H62.6292Z" fill="#F7C964" />
      <path d="M8.55525 0.705567C6.86364 0.704757 5.2098 1.20569 3.80294 2.14499C2.39609 3.08429 1.29943 4.41975 0.651705 5.98244C0.00398094 7.54512 -0.165705 9.26481 0.164112 10.924C0.493929 12.5831 1.30843 14.1071 2.50457 15.3033C3.70072 16.4994 5.22476 17.3139 6.88391 17.6437C8.54305 17.9736 10.2627 17.8039 11.8254 17.1562C13.3881 16.5084 14.7236 15.4118 15.6629 14.0049C16.6022 12.5981 17.1031 10.9442 17.1023 9.25261C17.1001 6.98646 16.1989 4.81375 14.5965 3.21134C12.9941 1.60892 10.8214 0.707738 8.55525 0.705567ZM8.55525 16.9962C7.02435 16.9978 5.52735 16.5454 4.25361 15.6961C2.97987 14.8469 1.98661 13.6389 1.39944 12.2251C0.812284 10.8113 0.657609 9.25509 0.95498 7.75335C1.25235 6.25161 1.98841 4.87179 3.07006 3.78843C4.15171 2.70506 5.53035 1.96681 7.03162 1.66705C8.53288 1.36729 10.0893 1.51949 11.5041 2.10441C12.9188 2.68932 14.1283 3.68067 14.9796 4.95305C15.8309 6.22544 16.2857 7.72171 16.2865 9.25261C16.2865 9.43298 16.2865 9.60925 16.2865 9.78142H11.5354V5.95268C11.5354 5.36406 11.3609 4.78866 11.0339 4.29925C10.7069 3.80983 10.2421 3.42838 9.69824 3.20312C9.15443 2.97787 8.55604 2.91893 7.97874 3.03376C7.40143 3.1486 6.87114 3.43204 6.45493 3.84826C6.03871 4.26447 5.75527 4.79476 5.64044 5.37207C5.5256 5.94937 5.58454 6.54777 5.80979 7.09158C6.03504 7.63539 6.41649 8.10019 6.90591 8.42721C7.39533 8.75422 7.97073 8.92877 8.55934 8.92877H10.7238V9.78142H8.55934C7.97055 9.78142 7.39499 9.95607 6.90549 10.2833C6.41598 10.6105 6.03453 11.0755 5.8094 11.6196C5.58427 12.1636 5.52557 12.7622 5.64074 13.3396C5.7559 13.917 6.03976 14.4473 6.45638 14.8634C6.873 15.2794 7.40368 15.5626 7.98125 15.6769C8.55883 15.7913 9.15735 15.7318 9.70109 15.5059C10.2448 15.28 10.7093 14.8979 11.0359 14.408C11.3624 13.918 11.5362 13.3422 11.5354 12.7534V11.4088H10.7156V12.7534C10.7164 13.1817 10.5901 13.6005 10.3528 13.957C10.1155 14.3135 9.77771 14.5916 9.38228 14.756C8.98685 14.9205 8.55153 14.9639 8.1314 14.8809C7.71128 14.7978 7.32523 14.592 7.02212 14.2894C6.71901 13.9869 6.51246 13.6013 6.42861 13.1813C6.34476 12.7613 6.38738 12.3259 6.55108 11.9302C6.71478 11.5344 6.9922 11.1962 7.34822 10.9581C7.70425 10.7201 8.12288 10.5931 8.55114 10.5931H16.1758C15.8604 12.3871 14.9243 14.013 13.5312 15.1866C12.1381 16.3601 10.3767 17.0065 8.55525 17.0126V16.9962ZM10.7238 5.95268V8.11301H8.55934C8.13224 8.1122 7.71497 7.98481 7.36025 7.74693C7.00552 7.50906 6.72926 7.17138 6.56638 6.77656C6.4035 6.38174 6.3613 5.9475 6.44512 5.52871C6.52894 5.10991 6.73501 4.72536 7.0373 4.42364C7.33959 4.12193 7.72454 3.91658 8.14349 3.83356C8.56244 3.75053 8.9966 3.79355 9.39111 3.95718C9.78562 4.12081 10.1228 4.39771 10.36 4.75288C10.5972 5.10806 10.7238 5.52558 10.7238 5.95268Z" fill="#F7C964" />
    </svg>
  );

export const SupportAgent = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="57" height="56" viewBox="0 0 57 56" fill="none">
  <mask id="mask0_532_290" style={{"maskType": "alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="57" height="56">
    <rect x="0.624878" width="56" height="56" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_532_290)">
    <path d="M28.6249 49C27.9638 49 27.4096 48.7764 26.9624 48.3292C26.5152 47.8819 26.2916 47.3278 26.2916 46.6667C26.2916 46.0056 26.5152 45.4514 26.9624 45.0042C27.4096 44.5569 27.9638 44.3333 28.6249 44.3333H44.9582V27.7667C44.9582 23.2167 43.3735 19.3569 40.2041 16.1875C37.0346 13.0181 33.1749 11.4333 28.6249 11.4333C24.0749 11.4333 20.2152 13.0181 17.0457 16.1875C13.8763 19.3569 12.2916 23.2167 12.2916 27.7667V39.6667C12.2916 40.3278 12.068 40.8819 11.6207 41.3292C11.1735 41.7764 10.6193 42 9.95823 42C8.6749 42 7.57629 41.5431 6.6624 40.6292C5.74851 39.7153 5.29156 38.6167 5.29156 37.3333V32.6667C5.29156 31.85 5.49573 31.0819 5.90407 30.3625C6.3124 29.6431 6.88601 29.0694 7.6249 28.6417L7.7999 25.55C8.11101 22.9056 8.87907 20.4556 10.1041 18.2C11.3291 15.9444 12.8652 13.9806 14.7124 12.3083C16.5596 10.6361 18.6791 9.33333 21.0707 8.4C23.4624 7.46667 25.9805 7 28.6249 7C31.2693 7 33.7777 7.46667 36.1499 8.4C38.5221 9.33333 40.6416 10.6264 42.5082 12.2792C44.3749 13.9319 45.911 15.8861 47.1166 18.1417C48.3221 20.3972 49.0999 22.8472 49.4499 25.4917L49.6249 28.525C50.3638 28.875 50.9374 29.4 51.3457 30.1C51.7541 30.8 51.9582 31.5389 51.9582 32.3167V37.6833C51.9582 38.4611 51.7541 39.2 51.3457 39.9C50.9374 40.6 50.3638 41.125 49.6249 41.475V44.3333C49.6249 45.6167 49.168 46.7153 48.2541 47.6292C47.3402 48.5431 46.2416 49 44.9582 49H28.6249ZM21.6249 32.6667C20.9638 32.6667 20.4096 32.4431 19.9624 31.9958C19.5152 31.5486 19.2916 30.9944 19.2916 30.3333C19.2916 29.6722 19.5152 29.1181 19.9624 28.6708C20.4096 28.2236 20.9638 28 21.6249 28C22.286 28 22.8402 28.2236 23.2874 28.6708C23.7346 29.1181 23.9582 29.6722 23.9582 30.3333C23.9582 30.9944 23.7346 31.5486 23.2874 31.9958C22.8402 32.4431 22.286 32.6667 21.6249 32.6667ZM35.6249 32.6667C34.9638 32.6667 34.4096 32.4431 33.9624 31.9958C33.5152 31.5486 33.2916 30.9944 33.2916 30.3333C33.2916 29.6722 33.5152 29.1181 33.9624 28.6708C34.4096 28.2236 34.9638 28 35.6249 28C36.286 28 36.8402 28.2236 37.2874 28.6708C37.7346 29.1181 37.9582 29.6722 37.9582 30.3333C37.9582 30.9944 37.7346 31.5486 37.2874 31.9958C36.8402 32.4431 36.286 32.6667 35.6249 32.6667ZM14.6832 29.05C14.411 24.9278 15.6555 21.3889 18.4166 18.4333C21.1777 15.4778 24.6193 14 28.7416 14C32.2027 14 35.2457 15.0986 37.8707 17.2958C40.4957 19.4931 42.0805 22.3028 42.6249 25.725C39.086 25.6861 35.8291 24.7333 32.8541 22.8667C29.8791 21 27.5943 18.4722 25.9999 15.2833C25.3777 18.3944 24.0652 21.1653 22.0624 23.5958C20.0596 26.0264 17.5999 27.8444 14.6832 29.05Z" fill="#204860"/>
  </g>
</svg>)

export const HumanFace = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none">
  <mask id="mask0_532_287" style={{"maskType": "alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="51" height="51">
    <rect width="51" height="51" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_532_287)">
    <path d="M19.1251 30.2812C18.3813 30.2812 17.7527 30.0245 17.2391 29.5109C16.7256 28.9974 16.4688 28.3687 16.4688 27.625C16.4688 26.8813 16.7256 26.2526 17.2391 25.7391C17.7527 25.2255 18.3813 24.9688 19.1251 24.9688C19.8688 24.9688 20.4975 25.2255 21.011 25.7391C21.5245 26.2526 21.7813 26.8813 21.7813 27.625C21.7813 28.3687 21.5245 28.9974 21.011 29.5109C20.4975 30.0245 19.8688 30.2812 19.1251 30.2812ZM31.8751 30.2812C31.1313 30.2812 30.5027 30.0245 29.9891 29.5109C29.4756 28.9974 29.2188 28.3687 29.2188 27.625C29.2188 26.8813 29.4756 26.2526 29.9891 25.7391C30.5027 25.2255 31.1313 24.9688 31.8751 24.9688C32.6188 24.9688 33.2475 25.2255 33.761 25.7391C34.2745 26.2526 34.5313 26.8813 34.5313 27.625C34.5313 28.3687 34.2745 28.9974 33.761 29.5109C33.2475 30.0245 32.6188 30.2812 31.8751 30.2812ZM25.5001 42.5C30.2459 42.5 34.2657 40.8531 37.5594 37.5594C40.8532 34.2656 42.5001 30.2458 42.5001 25.5C42.5001 24.65 42.4469 23.8266 42.3407 23.0297C42.2344 22.2328 42.0396 21.4625 41.7563 20.7188C41.0126 20.8958 40.2688 21.0286 39.5251 21.1172C38.7813 21.2057 38.0021 21.25 37.1876 21.25C33.9646 21.25 30.9188 20.5594 28.0501 19.1781C25.1813 17.7969 22.7376 15.8667 20.7188 13.3875C19.5855 16.15 17.9652 18.5495 15.8579 20.5859C13.7506 22.6224 11.298 24.1542 8.50006 25.1813V25.5C8.50006 30.2458 10.1469 34.2656 13.4407 37.5594C16.7344 40.8531 20.7542 42.5 25.5001 42.5ZM25.5001 46.75C22.5605 46.75 19.798 46.1922 17.2126 45.0766C14.6271 43.9609 12.3782 42.4469 10.4657 40.5344C8.55319 38.6219 7.03912 36.3729 5.9235 33.7875C4.80787 31.2021 4.25006 28.4396 4.25006 25.5C4.25006 22.5604 4.80787 19.7979 5.9235 17.2125C7.03912 14.6271 8.55319 12.3781 10.4657 10.4656C12.3782 8.55312 14.6271 7.03906 17.2126 5.92344C19.798 4.80781 22.5605 4.25 25.5001 4.25C28.4396 4.25 31.2021 4.80781 33.7876 5.92344C36.373 7.03906 38.6219 8.55312 40.5344 10.4656C42.4469 12.3781 43.961 14.6271 45.0766 17.2125C46.1922 19.7979 46.7501 22.5604 46.7501 25.5C46.7501 28.4396 46.1922 31.2021 45.0766 33.7875C43.961 36.3729 42.4469 38.6219 40.5344 40.5344C38.6219 42.4469 36.373 43.9609 33.7876 45.0766C31.2021 46.1922 28.4396 46.75 25.5001 46.75Z" fill="#204860"/>
  </g>
</svg>
)

export const Robot = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
  <mask id="mask0_532_275" style={{"maskType": "alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="56" height="56">
    <rect width="56" height="56" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_532_275)">
    <path d="M9.33334 35.0001C7.3889 35.0001 5.73612 34.3195 4.37501 32.9584C3.0139 31.5973 2.33334 29.9445 2.33334 28.0001C2.33334 26.0556 3.0139 24.4029 4.37501 23.0417C5.73612 21.6806 7.3889 21.0001 9.33334 21.0001V16.3334C9.33334 15.0501 9.79029 13.9515 10.7042 13.0376C11.6181 12.1237 12.7167 11.6667 14 11.6667H21C21 9.7223 21.6806 8.06953 23.0417 6.70841C24.4028 5.3473 26.0556 4.66675 28 4.66675C29.9445 4.66675 31.5972 5.3473 32.9583 6.70841C34.3195 8.06953 35 9.7223 35 11.6667H42C43.2833 11.6667 44.382 12.1237 45.2958 13.0376C46.2097 13.9515 46.6667 15.0501 46.6667 16.3334V21.0001C48.6111 21.0001 50.2639 21.6806 51.625 23.0417C52.9861 24.4029 53.6667 26.0556 53.6667 28.0001C53.6667 29.9445 52.9861 31.5973 51.625 32.9584C50.2639 34.3195 48.6111 35.0001 46.6667 35.0001V44.3334C46.6667 45.6167 46.2097 46.7154 45.2958 47.6292C44.382 48.5431 43.2833 49.0001 42 49.0001H14C12.7167 49.0001 11.6181 48.5431 10.7042 47.6292C9.79029 46.7154 9.33334 45.6167 9.33334 44.3334V35.0001ZM21 30.3334C21.9722 30.3334 22.7986 29.9931 23.4792 29.3126C24.1597 28.632 24.5 27.8056 24.5 26.8334C24.5 25.8612 24.1597 25.0348 23.4792 24.3542C22.7986 23.6737 21.9722 23.3334 21 23.3334C20.0278 23.3334 19.2014 23.6737 18.5208 24.3542C17.8403 25.0348 17.5 25.8612 17.5 26.8334C17.5 27.8056 17.8403 28.632 18.5208 29.3126C19.2014 29.9931 20.0278 30.3334 21 30.3334ZM35 30.3334C35.9722 30.3334 36.7986 29.9931 37.4792 29.3126C38.1597 28.632 38.5 27.8056 38.5 26.8334C38.5 25.8612 38.1597 25.0348 37.4792 24.3542C36.7986 23.6737 35.9722 23.3334 35 23.3334C34.0278 23.3334 33.2014 23.6737 32.5208 24.3542C31.8403 25.0348 31.5 25.8612 31.5 26.8334C31.5 27.8056 31.8403 28.632 32.5208 29.3126C33.2014 29.9931 34.0278 30.3334 35 30.3334ZM21 39.6667H35C35.6611 39.6667 36.2153 39.4431 36.6625 38.9959C37.1097 38.5487 37.3333 37.9945 37.3333 37.3334C37.3333 36.6723 37.1097 36.1181 36.6625 35.6709C36.2153 35.2237 35.6611 35.0001 35 35.0001H21C20.3389 35.0001 19.7847 35.2237 19.3375 35.6709C18.8903 36.1181 18.6667 36.6723 18.6667 37.3334C18.6667 37.9945 18.8903 38.5487 19.3375 38.9959C19.7847 39.4431 20.3389 39.6667 21 39.6667ZM14 44.3334H42V16.3334H14V44.3334Z" fill="#204860"/>
  </g>
</svg>)

export const SuccessIcon = () => (
    <svg class="success" height="75" viewBox="0 0 150 75" width="150" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd" transform="translate(0 2)">
      <g opacity=".493001" stroke="#4bca81" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" transform="translate(149)">
        <path d="m10.5 0v6"/>
        <path d="m10.5 14v6"/>
        <path d="m3.5 7v6" transform="matrix(0 -1 1 0 -6.5 13.5)"/>
        <path d="m17.5 7v6" transform="matrix(0 -1 1 0 7.5 27.5)"/>
      </g>
      <g opacity=".493001" stroke="#4bca81" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" transform="translate(68 103)">
        <path d="m8.5 0v4"/>
        <path d="m8.5 12v4"/>
        <path d="m2.5 6v4" transform="matrix(0 -1 1 0 -5.5 10.5)"/>
        <path d="m14.5 6v4" transform="matrix(0 -1 1 0 6.5 22.5)"/>
      </g>
      <path d="m119 24c3.865993 0 7 3.1340068 7 7s-3.134007 7-7 7h64c3.865993 0 7 3.1340068 7 7s-3.134007 7-7 7h22c3.865993 0 7 3.1340068 7 7s-3.134007 7-7 7h-19c-3.865993 0-7 3.1340068-7 7s3.134007 7 7 7h6c3.865993 0 7 3.1340068 7 7s-3.134007 7-7 7h-146c-3.8659932 0-7-3.1340068-7-7s3.1340068-7 7-7h-39c-3.86599325 0-7-3.1340068-7-7s3.13400675-7 7-7h40c3.8659932 0 7-3.1340068 7-7s-3.1340068-7-7-7h-25c-3.8659932 0-7-3.1340068-7-7s3.1340068-7 7-7h40c-3.8659932 0-7-3.1340068-7-7s3.1340068-7 7-7zm90 56c3.865993 0 7 3.1340068 7 7s-3.134007 7-7 7-7-3.1340068-7-7 3.134007-7 7-7z" fill="#4bca81" opacity=".204683"/>
      <circle class="success__circle" cx="119" cy="63" fill="#fff" r="48.5" stroke="#4bca81" stroke-width="3"/>
      <path d="m107.636557 35.3726612c-1.997911-.8660559-4.076131-1.5809105-6.220341-2.1301924-3.3319644-.8535491-6.8232737-1.3072867-10.4201894-1.3072867-1.4744401 0-2.9311348.0762427-4.3663827.2250138m-4.7382148.7679658c-1.3069168.2898579-2.5909631.6408076-3.8490122 1.0497115-.9291518.3020023-1.8441227.6356175-2.743653.9995813" fill="#fff" opacity=".351539" stroke="#4bca81" stroke-linecap="round" stroke-width="2.5" transform="matrix(.7193398 -.69465837 .69465837 .7193398 2.293353 72.984092)"/>
      <path class="success__check" d="m114.119231 74.3307692-11.423077-11.4923077c-.415385-.4153846-.415385-1.1076923 0-1.5230769l1.523077-1.5230769c.415384-.4153846 1.107692-.4153846 1.523077 0l8.584615 8.6538461c.276923.2769231.761539.2769231 1.038462 0l16.823077-16.9615384c.415384-.4153846 1.107692-.4153846 1.523076 0l1.523077 1.5230769c.415385.4153846.415385 1.1076923 0 1.5230769l-19.592307 19.8c-.415385.4846154-1.107693.4846154-1.523077 0z" fill="#4bca81"/>
    </g>
  </svg>
  )

export const PhoneIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
    </svg>
  );


  export const CallerIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="69" height="66" viewBox="0 0 69 66" fill="none">
      <mask id="mask0_479_1152" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="43" y="39" width="26" height="27">
        <rect x="43.125" y="39.8911" width="25.8751" height="25.8751" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_479_1152)">
        <path d="M47.4914 62.5318C47.168 62.5318 46.8984 62.424 46.6828 62.2083C46.4672 61.9927 46.3594 61.7232 46.3594 61.3997V57.0333C46.3594 56.7997 46.4402 56.5886 46.602 56.3999C46.7637 56.2113 46.9703 56.081 47.2219 56.0091L50.9414 55.2544C51.193 55.2185 51.449 55.2409 51.7096 55.3218C51.9701 55.4027 52.1813 55.524 52.343 55.6857L54.8766 58.2193C55.5594 57.824 56.2063 57.3882 56.8172 56.912C57.4282 56.4359 58.0121 55.9193 58.5692 55.3622C59.1621 54.7872 59.7057 54.1898 60.1998 53.5698C60.694 52.9499 61.1207 52.3075 61.4801 51.6427L58.8657 49.0013C58.7219 48.8575 58.6231 48.6868 58.5692 48.4892C58.5153 48.2915 58.5063 48.0489 58.5422 47.7614L59.243 43.988C59.2789 43.7544 59.3957 43.5522 59.5934 43.3815C59.791 43.2108 60.0157 43.1255 60.2672 43.1255H64.6336C64.9571 43.1255 65.2266 43.2333 65.4422 43.4489C65.6579 43.6646 65.7657 43.9341 65.7657 44.2575C65.7657 46.5036 65.276 48.7228 64.2967 50.915C63.3174 53.1072 61.9293 55.1017 60.1325 56.8986C58.3356 58.6954 56.341 60.0835 54.1488 61.0628C51.9567 62.0421 49.7375 62.5318 47.4914 62.5318Z" fill="#204860"/>
      </g>
      <mask id="mask1_479_1152" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="61" height="61">
        <rect width="60.3751" height="60.3751" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask1_479_1152)">
        <path d="M22.6407 35.8477C21.7602 35.8477 21.016 35.5438 20.408 34.9358C19.8001 34.3279 19.4961 33.5837 19.4961 32.7032C19.4961 31.8227 19.8001 31.0785 20.408 30.4706C21.016 29.8626 21.7602 29.5587 22.6407 29.5587C23.5211 29.5587 24.2653 29.8626 24.8733 30.4706C25.4812 31.0785 25.7852 31.8227 25.7852 32.7032C25.7852 33.5837 25.4812 34.3279 24.8733 34.9358C24.2653 35.5438 23.5211 35.8477 22.6407 35.8477ZM37.7345 35.8477C36.854 35.8477 36.1098 35.5438 35.5018 34.9358C34.8939 34.3279 34.5899 33.5837 34.5899 32.7032C34.5899 31.8227 34.8939 31.0785 35.5018 30.4706C36.1098 29.8626 36.854 29.5587 37.7345 29.5587C38.6149 29.5587 39.3591 29.8626 39.9671 30.4706C40.575 31.0785 40.879 31.8227 40.879 32.7032C40.879 33.5837 40.575 34.3279 39.9671 34.9358C39.3591 35.5438 38.6149 35.8477 37.7345 35.8477ZM30.1876 50.3126C35.8058 50.3126 40.5645 48.363 44.4638 44.4638C48.363 40.5645 50.3126 35.8058 50.3126 30.1876C50.3126 29.1813 50.2497 28.2065 50.1239 27.2631C49.9982 26.3198 49.7676 25.4079 49.4321 24.5274C48.5517 24.737 47.6712 24.8943 46.7907 24.9991C45.9103 25.1039 44.9879 25.1563 44.0235 25.1563C40.2082 25.1563 36.6024 24.3387 33.2063 22.7036C29.8102 21.0684 26.9172 18.7834 24.5274 15.8485C23.1857 19.1188 21.2676 21.9594 18.7729 24.3702C16.2782 26.781 13.3748 28.5943 10.0625 29.8102V30.1876C10.0625 35.8058 12.0121 40.5645 15.9114 44.4638C19.8106 48.363 24.5693 50.3126 30.1876 50.3126ZM30.1876 55.3439C26.7076 55.3439 23.4373 54.6835 20.3766 53.3628C17.3159 52.0421 14.6535 50.2497 12.3895 47.9857C10.1254 45.7216 8.33302 43.0592 7.01231 39.9985C5.6916 36.9378 5.03125 33.6675 5.03125 30.1876C5.03125 26.7076 5.6916 23.4373 7.01231 20.3766C8.33302 17.3159 10.1254 14.6535 12.3895 12.3895C14.6535 10.1254 17.3159 8.33302 20.3766 7.01231C23.4373 5.6916 26.7076 5.03125 30.1876 5.03125C33.6675 5.03125 36.9378 5.6916 39.9985 7.01231C43.0592 8.33302 45.7216 10.1254 47.9857 12.3895C50.2497 14.6535 52.0421 17.3159 53.3628 20.3766C54.6835 23.4373 55.3439 26.7076 55.3439 30.1876C55.3439 33.6675 54.6835 36.9378 53.3628 39.9985C52.0421 43.0592 50.2497 45.7216 47.9857 47.9857C45.7216 50.2497 43.0592 52.0421 39.9985 53.3628C36.9378 54.6835 33.6675 55.3439 30.1876 55.3439Z" fill="#204860"/>
      </g>
    </svg>
  );

export const PaypalIcon = (
  <svg id="CWPP_SVG_PPTM" className="PPTM" xmlns="http://www.w3.org/2000/svg" version="1.1" width="18px" height="18px" viewBox="0 0 18 18" focusable="false">
    <path id="Fill-8" className="PPTM-btm" fill="#009cde" d="M13.6023044,4.67342223 C13.8196336,3.28812419 13.6008532,2.34542498 12.8514484,1.49160831 C12.0263956,0.551629995 10.5359309,0.148937623 8.62894883,0.148937623 L3.09322219,0.148937623 C2.70355347,0.148937623 2.37175455,0.43245482 2.3109822,0.817370681 L0.00598653054,15.4327457 C-0.0395473836,15.7211605 0.183405526,15.9818221 0.475294243,15.9818221 L3.89269613,15.9818221 L3.65686311,17.4774071 C3.61713431,17.7297247 3.81196867,17.957917 4.06739398,17.957917 L6.94782221,17.957917 C7.28887304,17.957917 7.57912907,17.7097715 7.63228221,17.3731061 L7.66058217,17.226722 L8.20317953,13.7860604 L8.23819166,13.5959605 C8.29134479,13.2591138 8.58160082,13.0111496 8.92247024,13.0111496 L9.35331903,13.0111496 C12.1439493,13.0111496 14.329033,11.8774436 14.9674148,8.59894727 C15.2342689,7.22906764 15.0963973,6.08556642 14.3908938,5.28163282 C14.1773742,5.03856625 13.9119713,4.83740146 13.6023044,4.67342223"></path>
    <path id="Fill-9" className="PPTM-top" fill="#012169" d="M13.6023044,4.67384766 C13.8196336,3.28841937 13.6008532,2.34563151 12.8514484,1.49173456 C12.0263956,0.55166786 10.5359309,0.148937623 8.62894883,0.148937623 L3.09322219,0.148937623 C2.70355347,0.148937623 2.37175455,0.432481479 2.3109822,0.817433533 L0.00598653054,15.4341828 C-0.0395473836,15.7226247 0.183405526,15.9833109 0.475294243,15.9833109 L3.89269613,15.9833109 L4.75112833,10.5399219 L4.72446105,10.7106288 C4.78523341,10.3256767 5.11431118,10.0419515 5.50397989,10.0419515 L7.12832518,10.0419515 C10.3182389,10.0419515 12.815892,8.7459583 13.5457045,4.99802736 C13.5672923,4.88718584 13.5857961,4.7796097 13.6023044,4.67384766" fillOpacity="0.699999988079071"></path>
    <path id="Fill-10" className="PPTM-top" fill="#003087" d="M5.67323544,4.69235148 C5.70988026,4.46069089 5.85845507,4.27111742 6.05855031,4.17515152 C6.14961814,4.13161312 6.25120775,4.10730418 6.35769543,4.10730418 L10.6968416,4.10730418 C11.2109576,4.10730418 11.6902429,4.14104644 12.128348,4.21161494 C12.2537024,4.23175145 12.3754285,4.25497193 12.4938892,4.28127638 C12.6121686,4.30739943 12.7271825,4.33678785 12.8383869,4.36944165 C12.8940797,4.38558714 12.9486841,4.40263969 13.0025629,4.42059928 C13.2177152,4.49189341 13.4179919,4.57624907 13.6023044,4.67384766 C13.8196336,3.28841937 13.6008532,2.34563151 12.8514484,1.49173456 C12.0263956,0.55166786 10.5359309,0.148937623 8.62894883,0.148937623 L3.09322219,0.148937623 C2.70355347,0.148937623 2.37175455,0.432481479 2.3109822,0.817433533 L0.00598653054,15.4341828 C-0.0395473836,15.7226247 0.183405526,15.9833109 0.475294243,15.9833109 L3.89269613,15.9833109 L5.67323544,4.69235148"></path>
  </svg>
)

export const MedalIcon = (rank) => {
  if (rank === 1) {
    return '🥇';
  } else if (rank === 2) {
    return '🥈';
  } else if (rank === 3) {
    return '🥉';
  } else {
    return null;
  }
};